import radius from "./radius"

const border = {
  radius,
}

export default border
